<template>
  <div :class="className">
    <div>
      <template v-if="type === 'bar'">
        <div class="ten-progress__bar">
          <div
            class="ten-progress__bar-inner"
            :style="{ width: percent + '%' }"
          />
        </div>
      </template>
      <template v-else>
        <svg :viewBox="` 0 0 ${boxWidth} ${boxWidth} `">
          <path
            class="ten-progress__path-bg"
            fill="none"
            :d="path"
            :stroke-width="lineWidth"
          />
          <path
            class="ten-progress__path-value"
            fill="none"
            :d="path"
            :stroke-width="lineWidth"
            :stroke-dasharray="dashArray"
            :stroke-dashoffset="dashOffset"
          />
        </svg>
      </template>
      <span
        v-if="showText"
        class="ten-progress__valuetext"
      >{{ showText }}</span>
    </div>
    <p
      v-if="message"
      class="ten-progress__message"
    >
      {{ message }}
    </p>
  </div>
</template>

<script>
const name = 'ten-progress';

function getCirclePath(radius, lineWidth) {
  const halfLineWidth = lineWidth / 2;
  const drawRadius = radius - halfLineWidth;
  const path = `
    M ${radius} ${halfLineWidth} 
    A ${drawRadius} ${drawRadius} 0 0 1 ${radius} ${radius + drawRadius}
    A ${drawRadius} ${drawRadius} 0 0 1 ${radius} ${halfLineWidth}
  `;

  return path;
}

const SIZE_MAP = {
  small: {
    boxWidth: 48,
    lineWidth: 8,
  },
  default: {
    boxWidth: 90,
    lineWidth: 8,
  },
  large: {
    boxWidth: 146,
    lineWidth: 8,
  },
};

export default {
  name,
  props: {
    /**
     * 是否定义为内联元素
     */
    inline: {
      type: Boolean,
      default: false,
    },
    /**
     * 提示文本
     */
    message: String,
    /**
     * 进度条尺寸
     * @member 'large' | 'defalut' | 'small'
     */
    size: {
      type: String,
      default: 'default',
    },
    /**
     * 定义进度条形状
     * @member 'bar' | 'circle'
     */
    type: {
      type: String,
      default: 'bar',
      validator: val => ['bar', 'circle'].indexOf(val) > -1,
    },
    /**
     * 值为 0-1
     */
    value: { type: Number, validator: val => (val >= 0 && val <= 1) },
    /**
     * 获取进度条数值文本，默认使用 value 转换为百分比形式
     */
    valueText: { type: Function },
  },
  computed: {
    className() {
      return [
        'ten-progress',
        `ten-progress--size-${this.size}`,
        `ten-progress--type-${this.type}`,
        {
          'ten-progress--inline': this.inline,
          'ten-progress--block': !this.inline,
        },
      ];
    },
    showText() {
      if (this.valueText) return this.valueText(this.value);
      return `${this.percent}%`;
    },
    percent() {
      return parseInt(this.value * 100, 10);
    },
    dashOffset() {
      return this.pathLen * (1 - this.value);
    },
  },
  created() {
    this.initSvgPath();
  },
  methods: {
    initSvgPath() {
      const sizeMap = SIZE_MAP[this.size];
      this.boxWidth = sizeMap.boxWidth;
      this.lineWidth = sizeMap.lineWidth;
      this.path = getCirclePath(this.boxWidth / 2, this.lineWidth);
      this.pathLen = (Math.PI * 2 * (this.boxWidth - this.lineWidth)) / 2;
      this.dashArray = `${this.pathLen} ${this.pathLen}`;
    },
  },
};
</script>
